"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clock = void 0;
/* eslint-disable max-len */
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const clock = (_a) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    const classes = (0, classnames_1.default)('helix-icon', 'clock-outlined', className);
    return (react_1.default.createElement("svg", Object.assign({ className: classes, width: '20', height: '20', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', "aria-hidden": 'true' }, rest),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M9.75 4.36902C6.29822 4.36902 3.5 7.16724 3.5 10.619C3.5 14.0708 6.29822 16.869 9.75 16.869C13.2018 16.869 16 14.0708 16 10.619C16 7.16724 13.2018 4.36902 9.75 4.36902ZM2 10.619C2 6.33881 5.46979 2.86902 9.75 2.86902C14.0302 2.86902 17.5 6.33881 17.5 10.619C17.5 14.8992 14.0302 18.369 9.75 18.369C5.46979 18.369 2 14.8992 2 10.619ZM9.75 5.86902C10.1642 5.86902 10.5 6.2048 10.5 6.61902V10.2586L12.7185 12.0334C13.042 12.2921 13.0944 12.7641 12.8357 13.0875C12.5769 13.411 12.1049 13.4634 11.7815 13.2047L9.28148 11.2047C9.10357 11.0623 9 10.8469 9 10.619V6.61902C9 6.2048 9.33579 5.86902 9.75 5.86902Z', fill: '#4B5563' })));
};
exports.clock = clock;
